<template>
    <div class="index_home_container">
        <div class="index_yn">
            <div class="top">
                <div class="title-wrap">
                    <div>
                        <img
                            src="../../../assets/image/index-yn/logo.png"
                            style="width: 5rem;height: auto;"
                        />
                    </div>
                    <div class="title-right">
                        <div class="title-h2">
                            麦克奥翔安产业园
                        </div>
                        <div class="title-h3">智慧能碳综合管理平台</div>
                    </div>
                </div>
            </div>
            <!-- <img
                src="../../../assets/image/index-yn/index-home-sdg2.jpg"
                class="index_yn_bg"
            /> -->
        </div>
        <div class="index_lr">
            <div class="popss ssleft">
                <img src="../../../assets/image/index-yn/pop-left.png" />
                <!-- <img class="sider-tit" src="../../../assets/image/index-yn/left-su.png" /> -->
                <!-- <img
                    src="../../../assets/image/index-yn/left_gk.png"
                    style="
                        height: 100%;
                        width: 3rem;
                        position: absolute;
                        left: 0;
                    "
                /> -->
                <div class="left_top">
                    <div class="left_top_wrapper">
                        <div
                            class="div-content"
                            v-for="(item, index) in picData"
                            :key="index"
                        >
                            <div class="top_pic">
                                <img :src="item.img" />
                            </div>
                            <div>{{ item.name }}</div>
                            <div>{{ item.data }}{{ item.unit }}</div>
                        </div>
                    </div>
                </div>
                <div class="left_fle left_mid">
                    <div class="left_mid_title">
                        <div>变压器负载情况</div>
                        <!-- <template v-if="isUp">
                            <div
                                style="height: 1rem; width: 4.5rem;position: absolute;top: 0.6rem;right:0.8rem;cursor: pointer"
                                @click="upDownClick"
                            >
                                高/低
                                <img
                                    src="../../../assets/image/leaderpage/gaodi.jpg"
                                    style="height: 90%; width: auto;position: absolute;top: 0.2rem;right:0rem;"
                                />
                            </div>
                        </template>
                        <template v-else>
                            <div
                                style="height: 1rem; width: 4.5rem;position: absolute;top: 0.6rem;right:0.8rem;cursor: pointer"
                                @click="upDownClick"
                            >
                                高/低
                                <img
                                    src="../../../assets/image/leaderpage/gaodi.jpg"
                                    style="height: 90%; width: auto;position: absolute;top: 0.2rem;right:0rem;"
                                />
                            </div>
                        </template> -->
                    </div>
                    <div class="left_mid_cnt left_mid_short">
                        <div
                            class="left_mid_box"
                            v-for="item in byqDatas"
                            :key="item.d_id"
                        >
                            <div class="left_mid_box_title">
                                {{ item.name }}
                            </div>
                            <table
                                class="left_mid_box_table"
                                width="100%"
                                border="0"
                                cellspacing="0"
                                cellpadding="0"
                            >
                                <tr>
                                    <td></td>
                                    <td>
                                        电压(V)
                                    </td>
                                    <td>
                                        电流(A)
                                    </td>
                                    <td>
                                        温度(℃)
                                    </td>
                                </tr>
                                <tr>
                                    <td>A相</td>
                                    <td class="table_data">{{ item.ua }}</td>
                                    <td class="table_data">{{ item.ia }}</td>
                                    <td class="table_data">{{ item.ta }}</td>
                                </tr>
                                <tr>
                                    <td>B相</td>
                                    <td class="table_data">{{ item.ub }}</td>
                                    <td class="table_data">{{ item.ib }}</td>
                                    <td class="table_data">{{ item.tb }}</td>
                                </tr>
                                <tr>
                                    <td>C相</td>
                                    <td class="table_data">{{ item.uc }}</td>
                                    <td class="table_data">{{ item.ic }}</td>
                                    <td class="table_data">{{ item.tc }}</td>
                                </tr>
                            </table>
                        </div>

                        <!-- <div
                            class="div-content"
                            v-for="(item, index) in bianyaqiData"
                            :key="index"
                        >
                            <div style="display: flex; align-items: center">
                                <el-tooltip
                                    effect="light"
                                    :content="item.transformer_name"
                                    placement="bottom"
                                >
                                    <div class="byq_width">
                                        {{ item.transformer_name }}
                                    </div>
                                </el-tooltip>
                                <div style="flex: 1">
                                    <el-progress
                                        :text-inside="true"
                                        :stroke-width="item.width"
                                        :percentage="item.transformer_rate"
                                        :color="item.color"
                                    ></el-progress>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="left_fle left_bot">
                    <div class="left_mid_title left_mid_margin">
                        <div>告警事件</div>
                    </div>
                    <div class="left_mid_cnt" style>
                        <div
                            class="div-content"
                            v-for="(item, index) in gaojingData"
                            :key="index"
                        >
                            <div class="gaojing">
                                <div class="gaojing_one">
                                    <img
                                        src="../../../assets/image/index-yn/alarm.png"
                                    />
                                </div>
                                <div class="gaojing_two">
                                    {{ item.op_date }}
                                </div>
                                <div class="gaojing_three">
                                    <div class="txt_elli">
                                        <span>{{ item.point_name }}</span>
                                    </div>
                                    <div
                                        style="margin-top: 5px;"
                                        class="txt_elli"
                                    >
                                        <span class="color_green">
                                            {{ item.warn_detail }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popss ssright">
                <img src="../../../assets/image/index-yn/pop-right.png" />
                <div class="left_fle right_top">
                    <div style="display: flex; align-items: center;">
                        <div
                            :class="[
                                select_type == '001'
                                    ? 'right_title_tab_select'
                                    : 'right_title_tab_unselect'
                            ]"
                            @click="changeSelectType('001')"
                        >
                            <div>电量情况</div>
                        </div>
                        <div
                            :class="[
                                select_type == '002'
                                    ? 'right_title_tab_select'
                                    : 'right_title_tab_unselect'
                            ]"
                            @click="changeSelectType('002')"
                        >
                            <div>用水情况</div>
                        </div>
                        <!-- <div
                            :class="[
                                select_type == '006'
                                    ? 'right_title_tab_select'
                                    : 'right_title_tab_unselect'
                            ]"
                            @click="changeSelectType('006')"
                        >
                            <div>用气情况</div>
                        </div> -->
                    </div>
                    <div class="right_mid_cnt right_cnt_sj">
                        <div
                            class="div-content"
                            v-for="(item, index) in dianliangData"
                            :key="index"
                        >
                            <div style="display: flex; align-items: center">
                                <div style="width: 20%">
                                    <img
                                        :src="item.img"
                                        style="width: 30px; height: auto"
                                    />
                                </div>
                                <div style="width: 40%">{{ item.name }}</div>
                                <div style="flex: 1">
                                    {{ item.data }}&nbsp;{{ item.unit }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="left_fle right_top_chart">
                    <v-chart :auto-resize="true" :options="bar" ref="bar" />
                </div>
                <div class="left_fle right_bot">
                    <div class="left_mid_title">
                        <div>需量情况</div>
                    </div>
                    <div class="right_mid_cnt right_cnt_sj">
                        <div
                            class="div-content"
                            v-for="(item, index) in fuheData"
                            :key="index"
                        >
                            <div style="display: flex; align-items: center">
                                <div style="width: 20%">
                                    <img
                                        :src="item.img"
                                        style="width: 30px; height: auto"
                                    />
                                </div>
                                <div style="width: 45%">{{ item.name }}</div>
                                <div class="cnt_data">
                                    <i>{{ item.data }}</i>
                                    &nbsp;{{ item.unit }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="left_fle right_bot_chart">
                    <v-chart :auto-resize="true" :options="fuhe" ref="fuhe" />
                </div>
            </div>
            <!-- <div class="ssbottom">
                技术支持：天津远海金风启航新能源有限公司&nbsp;&nbsp;&nbsp;版本号：1.0.5.0919
            </div> -->
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as api from "@/http/api.js";
import { getDataAll } from "@/http/http-60.js";
import { getCommonInfo, getCommonList } from "@/http/Use_electricity_monitor";
import { departmentColor } from "@/utils/chart-color.js";
import moment from "moment";
export default {
    name: "Main",
    components: {},
    data() {
        return {
            byqDatas: [
                {
                    name: "1#变压器",
                    d_id: "1572411373249327104",
                    t_id: "1594952648456400896",
                    ia: "",
                    ib: "",
                    ic: "",
                    ua: "",
                    ub: "",
                    uc: "",
                    ta: "",
                    tb: "",
                    tc: ""
                },
                {
                    name: "2#变压器",
                    d_id: "1572417074029883392",
                    t_id: "1594952747144179712",
                    ia: "",
                    ib: "",
                    ic: "",
                    ua: "",
                    ub: "",
                    uc: "",
                    ta: "",
                    tb: "",
                    tc: ""
                },
                {
                    name: "3#变压器",
                    d_id: "1572133868747481088",
                    t_id: "1594953344144633856",
                    ia: "",
                    ib: "",
                    ic: "",
                    ua: "",
                    ub: "",
                    uc: "",
                    ta: "",
                    tb: "",
                    tc: ""
                },
                {
                    name: "4#变压器",
                    d_id: "1572136675764461568",
                    t_id: "1594953414101430272",
                    ia: "",
                    ib: "",
                    ic: "",
                    ua: "",
                    ub: "",
                    uc: "",
                    ta: "",
                    tb: "",
                    tc: ""
                }
            ],
            options: [
                { label: "11", value: "222" },
                { label: "22", value: "333" }
            ],
            curHoverPic: 0,
            picData: [
                {
                    img: require("../../../assets/image/index-yn/zhuangji.png"),
                    name: "进线数量",
                    data: "2",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/peidianshi.png"),
                    name: "变电所数量",
                    data: "3",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/jisuan.png"),
                    name: "计算装置数量",
                    data: "5",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/caiji.png"),
                    name: "采集器数量",
                    data: "67",
                    unit: "个"
                }
            ],
            dianliangData: [],
            fuheData: [
                {
                    img: require("../../../assets/image/index-yn/fuhe1.png"),
                    name: "当日最大需量",
                    data: "",
                    unit: "kW"
                },
                {
                    img: require("../../../assets/image/index-yn/dianliang2.png"),
                    name: "当月最大需量",
                    data: "",
                    unit: "kW"
                }
            ],
            bianyaqiData: [],
            gaojingData: [],
            fuheXData: [],
            fuheLegend: [],
            fuheSeries: [],
            xAxis: [
                {
                    name: this.xAxis_unit,
                    type: "category",
                    data: [],
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                }
            ],
            series: [],
            selectDate: "",
            activeLine: "",
            activeBlk: "",
            activeBlkUrl: "",
            curBox: "",
            active_power: "",
            month_active_power: "",
            activeData: [],
            isUp: false, //默认大到小
            select_type: "001", //1电量情况  2用水情况
            unit: "",
            xAxis_unit: "",
            legendData: [],
            byqTimer: null
        };
    },
    created() {},
    mounted() {
        this.getSysDate();
        this.timer = setInterval(() => {
            this.getSysDate();
            this.getCommonInfo();
            this.getCommonList();
        }, 60000);
        // 变压器数据
        this.getBYQData();
        this.setByqTimer();
    },

    methods: {
        setByqTimer() {
            if (this.byqTimer) {
                clearInterval(this.byqTimer);
            }
            this.byqTimer = setInterval(() => {
                this.getBYQData();
            }, 1000 * 20);
        },
        // 变压器负载情况
        getBYQData() {
            let d_pointIds = [];
            this.byqDatas.forEach(item => {
                d_pointIds.push(item.d_id);
            });
            // 获取电数据
            getDataAll(d_pointIds).then(res => {
                let valueJson = res.bus_json;
                this.byqDatas.forEach(item => {
                    let point = valueJson[item.d_id];
                    item.ua = point && point.v_a;
                    item.ub = point && point.v_b;
                    item.uc = point && point.v_c;
                    item.ia = point && point.a_a;
                    item.ib = point && point.a_b;
                    item.ic = point && point.a_c;
                });
            });
            let t_pointIds = [];
            this.byqDatas.forEach(item => {
                t_pointIds.push(item.t_id);
            });
            // 获取温度数据
            getDataAll(t_pointIds).then(res => {
                let valueJson = res.bus_json;
                this.byqDatas.forEach(item => {
                    let point = valueJson[item.t_id];
                    item.ta = point && point.wendu_A;
                    item.tb = point && point.wendu_B;
                    item.tc = point && point.wendu_C;
                });
            });
        },
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate1().then(res => {
                if (res) {
                    // this.systemDate = res.bus_json;
                    this.selectDate = res.bus_json.sysdate;
                    this.getGaojingList(
                        `${res.bus_json.sysdate4}-01-01`,
                        res.bus_json.sysdate
                    );
                    this.changeSelectType(this.select_type);
                    this.getTransformerLoad();
                    this.getDemandList();
                    this.getDemandDataList();
                }
            });
        },
        changeSelectType(type) {
            this.select_type = type;
            if (type == "001") {
                this.getYongDian();
            } else {
                this.getCommonInfo();
                this.getCommonList();
            }
        },
        // 右侧电量
        getYongDian() {
            api.getElecInfo({
                point_id: "1522104092439265282",
                date: this.selectDate
            }).then(res => {
                if (res) {
                    this.dianliangData = [
                        {
                            img: require("../../../assets/image/index-yn/dianliang1.png"),
                            name: "当日用电量",
                            data: res.bus_json.active_power_day,
                            unit: res.bus_json.dayUnit
                        },
                        {
                            img: require("../../../assets/image/index-yn/dianliang2.png"),
                            name: "当月用电量",
                            data: res.bus_json.active_power_month,
                            unit: res.bus_json.monthUnit
                        },
                        {
                            img: require("../../../assets/image/index-yn/dianliang3.png"),
                            name: "当年用电量",
                            data: res.bus_json.active_power_year,
                            unit: res.bus_json.yearUnit
                        }
                    ];

                    this.xAxis[0].data = res.bus_json.hour_list;
                    this.unit = res.bus_json.dayUnit;
                    this.xAxis_unit = "时";
                    this.legendData = [
                        {
                            name: "尖电量",
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        {
                            name: "峰电量",
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        {
                            name: "平电量",
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        {
                            name: "谷电量",
                            textStyle: {
                                color: "#fff"
                            }
                        }
                    ];
                    this.series = [
                        {
                            name: "尖电量",
                            type: "bar",
                            stack: "elc",
                            data: res.bus_json.sharp_power_list,
                            itemStyle: {
                                color: "#fe7f66"
                            }
                        },
                        {
                            name: "峰电量",
                            type: "bar",
                            data: res.bus_json.peak_power_list,
                            stack: "elc",
                            itemStyle: {
                                color: "#fdca50"
                            }
                        },
                        {
                            name: "平电量",
                            type: "bar",
                            data: res.bus_json.off_power_list,
                            stack: "elc",
                            itemStyle: {
                                color: "#0091ea"
                            }
                        },
                        {
                            name: "谷电量",
                            type: "bar",
                            data: res.bus_json.shoulder_power_list,
                            stack: "elc",
                            itemStyle: {
                                color: "#29b85e"
                            }
                        }
                    ];
                }
            });
        },
        getCommonInfo() {
            getCommonInfo({
                point_id:
                    this.select_type == "002"
                        ? "1572157460025565184"
                        : "1526170470976585728",
                date: this.selectDate,
                point_class_id: this.select_type
            }).then(res => {
                this.dianliangData = [
                    {
                        img: require("../../../assets/image/index-yn/water_day.png"),
                        name: "当日用水量",
                        data: res.bus_json.active_power_day,
                        unit: res.bus_json.dayUnit
                    },
                    {
                        img: require("../../../assets/image/index-yn/water_month.png"),
                        name: "当月用水量",
                        data: res.bus_json.active_power_month,
                        unit: res.bus_json.monthUnit
                    },
                    {
                        img: require("../../../assets/image/index-yn/water_year.png"),
                        name: "当年用水量",
                        data: res.bus_json.active_power_year,
                        unit: res.bus_json.yearUnit
                    }
                ];
            });
        },
        getCommonList() {
            getCommonList({
                date: moment(new Date()).format("YYYY-MM"),
                point_id:
                    this.select_type == "002"
                        ? "1572157460025565184"
                        : "1526170470976585728",
                point_class_id: this.select_type
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.xAxis[0].data = res.bus_json.time_list;
                    this.xAxis_unit = "日";
                    this.unit = res.bus_json.dayUnit;
                    this.legendData = [
                        {
                            name: "用水量",
                            textStyle: {
                                color: "#fff"
                            }
                        }
                    ];
                    this.series = [
                        {
                            name: "用水量",
                            type: "bar",
                            stack: "elc",
                            data: res.bus_json.active_power_list,
                            itemStyle: {
                                color: "#fe7f66"
                            }
                        }
                    ];
                }
            });
        },
        upDownClick() {
            this.isUp = !this.isUp;
            this.getTransformerLoad();
        },
        // 右下角曲线
        getDemandDataList() {
            api.getDemandDataList().then(res => {
                if (res) {
                    this.fuheXData = res.bus_json.year_month_list;
                    const list = res.bus_json.list;
                    this.fuheLegend = [];
                    this.fuheSeries = [];
                    list &&
                        list.length &&
                        list.forEach((item, index) => {
                            this.fuheLegend.push(item.name);
                            let series = {
                                name: item.name,
                                type: "line",
                                data: item.maxdemand_list,
                                itemStyle: {
                                    color: departmentColor[index]
                                }
                            };
                            this.fuheSeries.push(series);
                        });
                }
            });
        },
        // 右下角负荷情况
        getDemandList() {
            api.getDemandList().then(res => {
                if (res) {
                    this.fuheData[0].data = res.bus_json.demand;
                    this.fuheData[1].data = res.bus_json.month_demand;
                }
            });
        },
        // 左侧变压器负载
        getTransformerLoad() {
            api.getTransformerLoad({
                type: this.isUp ? "0" : "1"
            }).then(res => {
                if (res) {
                    this.bianyaqiData = res.bus_json.transformerRateList;
                    this.bianyaqiData &&
                        this.bianyaqiData.length &&
                        this.bianyaqiData.forEach(item => {
                            item.width = 15;
                            if (item.transformer_rate >= 80)
                                item.color = "#e6a23c";
                            else item.color = "#1989fa";
                        });
                }
            });
        },
        // 左侧告警
        getGaojingList(from_date, to_date) {
            api.getWarn_dataList({
                pageNum: 1,
                pageSize: 5,
                from_date,
                to_date
            }).then(res => {
                if (res) {
                    this.gaojingData = res.bus_json.items;
                }
            });
        }
    },
    computed: {
        bar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.legendData,
                    itemWidth: 8,
                    itemHeight: 8,
                    right: "10%"
                },
                calculable: true,
                xAxis: this.xAxis,
                grid: {
                    left: "5%",
                    right: "10%",
                    bottom: "0%",
                    top: "25%",
                    containLabel: true
                },
                yAxis: [
                    {
                        type: "value",
                        name: this.unit,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: this.series
            };
            return options;
        },
        fuhe() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.fuheLegend,
                    itemWidth: 10,
                    itemHeight: 10,
                    right: "10%",
                    textStyle: {
                        color: "#fff",
                        fontSize: 10
                    }
                },
                grid: {
                    left: "5%",
                    right: "10%",
                    bottom: "0%",
                    top: "37%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "月",
                        data: this.fuheXData,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kW",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: this.fuheSeries
            };
            return options;
        }
    },
    destroyed() {
        clearInterval(this.timer);
        clearInterval(this.byqTimer);
    }
};
</script>
<style lang="scss">
.index_home_container {
    width: 100%;
    //height: calc(100% + 135px + 3rem);
    height: calc(100% + #{px2Rem(220px)});
    background-image: url("../../../assets/image/index-yn/index-home-sdg2.jpg");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    // .el-tooltip__popper {
    //     z-index: 9999999999 !important;
    // }
    .span-ellipsis {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
        color: #ffffff;
        font-size: 14px;
    }
    .index_yn {
        position: relative;
        //  height: 100%;
        width: 100%;
        .top {
            height: 135px;
            width: 100%;
            // background-image: url("../../../assets/image/leaderpage/top_index2.png");
            // background-repeat: no-repeat;
            // background-position: top center;
            position: absolute;
            .title-wrap {
                width: 100%;
                height: 9rem;
                display: flex;
                flex-direction: row;
                .title-right {
                    display: flex;
                    flex-flow: column nowrap;
                    margin-left: 0.5rem;
                }
                .title-h2 {
                    text-align: center;
                    letter-spacing: 10px;
                    font-size: 2rem;
                    font-weight: 550;
                    color: #fff;
                    // line-height: 60px;
                }
                .title-h3 {
                    text-align: center;
                    letter-spacing: 5px;
                    font-size: 1.6rem;
                    font-weight: 500;
                    color: #fff;
                    margin-top: 0.5rem;
                }
            }
        }
        .index_yn_bg {
            width: 100%;
            height: 100%;
        }
        .pic_one {
            position: absolute;
            top: 27.96%;
            left: 11.9%;
            width: 23.2rem;
            z-index: 998;
        }
        .pic_two {
            position: absolute;
            top: 36.8%;
            left: 12.75%;
            width: 22.2rem;
            z-index: 998;
        }
        .pic_three {
            position: absolute;
            top: 32.6%;
            left: 30.8%;
            width: 32rem;
            z-index: 998;
        }
        .pic_four {
            position: absolute;
            top: 20.3%;
            left: 53.2%;
            width: 43rem;
            z-index: 998;
        }
        .pic_five {
            position: absolute;
            top: 66.4%;
            left: 28.1%;
            width: 11.2rem;
            z-index: 998;
        }
        .pic_six {
            position: absolute;
            top: 53.8%;
            left: 34.5%;
            width: 43.5rem;
            z-index: 998;
        }
        .pic_line {
            width: 5rem;
            position: absolute;
            z-index: 1000;
        }
        .pic_line_one {
            top: 28%;
            left: 22%;
        }
        .pic_line_two {
            top: 34%;
            left: 22%;
        }
        .pic_line_three1 {
            top: 30%;
            left: 32%;
        }
        .pic_line_three2 {
            top: 33%;
            left: 42%;
        }
        .pic_line_three3 {
            top: 36%;
            left: 51%;
        }
        .pic_line_four {
            top: 28%;
            left: 69%;
        }
        .pic_line_five {
            top: 62%;
            left: 27%;
        }
        .pic_line_six {
            top: 62%;
            left: 43%;
        }
        .box1 {
            position: absolute;
            top: 14%;
            left: 21%;
            z-index: 998;
        }
        .box2 {
            position: absolute;
            top: 20%;
            left: 21%;
            z-index: 998;
        }
        .box31 {
            position: absolute;
            top: 15%;
            left: 31%;
            z-index: 998;
        }
        .box32 {
            position: absolute;
            top: 18%;
            left: 41%;
            z-index: 998;
        }
        .box33 {
            position: absolute;
            top: 23%;
            left: 51%;
            z-index: 998;
        }
        .box4 {
            position: absolute;
            top: 14%;
            left: 69%;
            z-index: 998;
        }
        .box5 {
            position: absolute;
            top: 49%;
            left: 27%;
            z-index: 998;
        }
        .box6 {
            position: absolute;
            top: 48%;
            left: 42%;
            z-index: 998;
        }
        .yuan_img {
            width: 10rem;
            height: 10rem;
            .a4 {
                .left-title {
                    position: absolute;
                    left: 50%;
                    top: 45%;
                    transform: translate(-50%, -50%);
                    cursor: pointer;
                    width: 8rem;
                    text-align: center;
                }
                .title-style {
                    color: #e08467;
                    font-size: 1.1rem;
                    font-weight: bold;
                }
                .title-style2 {
                    color: #fff;
                    display: inline-block;
                    margin-top: 5px;
                    font-size: 0.9rem;
                    font-weight: bold;
                }
            }
            .a1,
            .a2,
            .a3 {
                position: absolute;
                top: -0.5rem;
                animation: rotateAr 6s linear 1s infinite reverse;
                -webkit-animation: rotateAr 6s linear 1s infinite reverse;
                -moz-animation: rotateAr 6s linear 1s infinite reverse;
                -ms-animation: rotateAr 6s linear 1s infinite reverse;
                -o-animation: rotateAr 6s linear 1s infinite reverse;

                .hover-wrap {
                    z-index: 55;
                    cursor: pointer;
                }
                .hover-down {
                    display: none;
                    position: absolute;
                }
            }
            .a1 {
                z-index: 9;
                img {
                    width: 6rem;
                    height: 6rem;
                    margin: 2rem 2rem;
                }
            }
            .a2 {
                z-index: 9;
                img {
                    width: 8rem;
                    height: 8rem;
                    margin: 1rem 1rem;
                }
            }
            .a3 img {
                width: 10rem;
                height: 10rem;
            }
        }
        .animate__animated.animate__bounceIn {
            --animate-duration: 1.5s;
        }
    }
    .index_lr {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .popss {
            position: absolute;
            .left_fle {
                width: 100%;
                position: absolute;
                color: #fff;
                padding: 12px;
                padding-left: 30px;
                box-sizing: border-box;
                .left_mid_cnt {
                    display: flex;
                    //  justify-content: space-around;
                    flex-flow: column;
                    height: calc(100% - 20px);
                    //margin-top: 1rem;
                    .div-content > div > div {
                        font-size: 0.4rem;
                    }
                    .div-content {
                        margin-top: 0.8rem;
                        .gaojing {
                            display: flex;
                            align-items: center;
                        }
                        .gaojing_one {
                            width: 5%;
                            img {
                                width: 22px;
                                height: 22px;
                            }
                        }
                        .gaojing_two {
                            width: 45%;
                            text-align: center;
                        }
                        .gaojing_three {
                            width: 50%;
                            display: flex;
                            flex-flow: column wrap;
                            .txt_elli {
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                    .byq_width {
                        width: 75px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }

                .left_mid_short {
                    // width: calc(100% - 2.5rem) !important;
                }
                .right_mid_cnt {
                    display: flex;
                    justify-content: space-around;
                    flex-flow: column;
                    height: calc(100% - 20px);
                    .div-content > div > div {
                        font-size: 0.9rem;
                    }
                }
                .left_mid_title {
                    height: 20px;
                    width: 7.5rem;
                    background: url(../../../assets/image/index-yn/title.png);
                    background-size: 100% 100%;
                    margin-bottom: 5px;
                    // padding: 0 0 0 10px;
                    div {
                        text-align: center;
                        font-size: 0.7rem;
                    }
                    &:first-child {
                        height: 20px;
                        line-height: 20px;
                        font-size: 0.9rem;
                    }
                }
                .right_title_tab_unselect {
                    height: 20px;
                    flex: 1;
                    margin-bottom: 5px;
                    background: url(../../../assets/image/index-yn/title.png);
                    background-size: 100% 100%;
                    div {
                        text-align: center;
                        font-size: 0.9rem;
                        height: 20px;
                        line-height: 20px;
                        font-size: 0.9rem;
                    }
                }
                .right_title_tab_select {
                    height: 20px;
                    flex: 1;
                    margin-bottom: 5px;
                    background: url(../../../assets/image/index-yn/title_selected.png);
                    background-size: 100% 100%;
                    div {
                        text-align: center;
                        font-size: 0.9rem;
                        height: 20px;
                        line-height: 20px;
                        font-size: 0.9rem;
                    }
                }
                .left_mid_margin {
                    margin-left: 2rem;
                }
            }
        }
        .ssleft {
            top: 2%;
            left: 0;
            transform: perspective(1000px) rotateY(15deg);
            transition: all 0.6s;
            height: 96%;
            z-index: 999;
            img {
                width: 450px;
                height: 100%;
                transition: width 0.6s;
            }
            &:hover {
                top: 0;
                transform: perspective(1000px) rotateY(0deg);
                height: 100%;
                img {
                    width: 550px;
                    height: 100%;
                }
                .left_top .left_top_wrapper > div .top_pic > img {
                    width: 37px;
                    height: 29px;
                }
                .left_mid_title {
                    width: 150px;
                    div {
                        font-size: 0.8rem;
                    }
                    &:first-child {
                        height: 25px;
                        line-height: 25px;
                    }
                }
                .left_top .left_top_wrapper > div > div {
                    font-size: 0.8rem;
                }
                .left_fle .left_mid_cnt {
                    .byq_width {
                        width: 120px;
                    }
                    .div-content > div > div {
                        font-size: 0.8rem;
                    }
                }
                // .left_bot .left_mid_cnt .div-content > div > div {
                //     font-size: 0.7rem;
                // }
            }
            .left_top {
                width: 100%;
                height: 25%;
                position: absolute;
                top: 0;
                color: #fff;
                margin-left: 1.5rem;
                width: calc(100% - 1rem);
                .left_top_wrapper {
                    display: flex;
                    flex-flow: row wrap;
                    height: 100%;
                    padding: 1rem;
                    box-sizing: border-box;

                    > div {
                        height: 33%;
                        width: 50%;
                        text-align: center;
                        .top_pic {
                            height: 40%;
                            width: 100%;
                            > img {
                                width: 29px;
                                height: 24px;

                                transition: none;
                            }
                        }
                        > div {
                            font-size: 0.9rem;
                            margin-top: 4px;
                        }
                    }
                }
            }
            .left_mid {
                height: 38%;
                top: 25%;
                margin-left: 3rem;
                width: calc(100% - 3rem);
                .left_mid_box {
                    height: 25%;
                    width: 100%;
                    border-bottom: 1px solid #172c32;
                    display: flex;
                    padding: 5px;
                    box-sizing: border-box;
                    .left_mid_box_title {
                        width: 25%;
                        justify-content: center;
                        color: #fff;
                        display: flex;
                        align-items: center;
                    }
                    .left_mid_box_table {
                        flex: 1;
                        td {
                            text-align: center;
                        }
                        .table_data {
                            color: #56d4be;
                        }
                    }
                }
            }
            .left_bot {
                height: 31%;
                top: 62%;
                //  margin-left: 1rem;
                // .left_mid_cnt {
                //     margin-left: 0.5rem;
                // }
            }
            .sider-tit {
                position: absolute;
                top: 50%;
                left: 3px;
                transform: translate(0, -50%);
                width: 2rem;
                height: auto;
            }
        }
        .ssright {
            top: 2%;
            right: 0;
            transform: perspective(1000px) rotateY(-15deg);
            transition: all 0.6s;
            height: 96%;
            z-index: 999;
            img {
                width: 450px;
                height: 100%;
                transition: width 0.6s;
            }
            &:hover {
                top: 0;
                transform: perspective(1000px) rotateY(0deg);
                height: 100%;
                img {
                    width: 550px;
                    height: 100%;
                }
                .left_mid_title {
                    width: 150px;
                    div {
                        font-size: 0.8rem;
                    }
                    &:first-child {
                        height: 25px;
                        line-height: 25px;
                    }
                }
                .right_top .right_mid_cnt .div-content > div > div {
                    font-size: 0.8rem;
                }
                .right_bot .right_mid_cnt .div-content > div > div {
                    font-size: 0.8rem;
                }
                .right_top .right_title_tab_unselect div {
                    font-size: 0.8rem;
                }
                .right_top .right_title_tab_select div {
                    font-size: 0.8rem;
                }
            }
            .right_top {
                width: 100%;
                height: 22%;
                position: absolute;
                top: 2%;
                color: #fff;
            }
            .right_top_chart {
                width: 100%;
                height: 26%;
                position: absolute;
                top: 24%;
                color: #fff;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
            .right_bot {
                width: 100%;
                height: 15%;
                position: absolute;
                top: 50%;
                color: #fff;
            }
            .right_bot_chart {
                width: 100%;
                height: 33%;
                position: absolute;
                top: 65%;
                color: #fff;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
            .right_cnt_sj {
                margin-left: 1rem;
            }
        }
        .ssbottom {
            position: absolute;
            bottom: 5px;
            right: 20px;
            font-size: 0.7rem;
            color: #fff;
            z-index: 9999;
        }
    }
    .el-progress-bar__outer {
        background-color: rgb(255 255 255 / 40%);
    }
    @media screen and (max-width: 1380px) {
        .ssleft .left_bot .left_mid_cnt .div-content {
            margin-top: 0.4rem !important;
        }
    }
}
/*  */
@keyframes rotateAr {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes rotateAr {
    from {
        -webkit-transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
    }
}

@-moz-keyframes rotateAr {
    from {
        -moz-transform: rotate(0deg);
    }
    to {
        -moz-transform: rotate(360deg);
    }
}

@-ms-keyframes rotateAr {
    from {
        -ms-transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
    }
}

@-o-keyframes rotateAr {
    from {
        -o-transform: rotate(0deg);
    }
    to {
        -o-transform: rotate(360deg);
    }
}
</style>
